import React from 'react';
import { useSelector } from 'react-redux';
import { Polygon } from 'react-leaflet';
import {
    mapOptionsState,
    multiPolygonEditedIDState,
    multiPolygonsInfoState,
} from '../../../../../../../app/redux/retrievers/retrievers';
import { theme } from '../../../../../../../core/theme/theme';
import { filterPolygonPointsByDistance } from '../../../../../../../core/utils/map.utils';
import { PolygonInfo } from '../../../../../../../core/types/types';

const MultiPolygonsUnEditable = () => {
    const multiPolygonsInfo: PolygonInfo = useSelector(multiPolygonsInfoState);
    const multiPolygonEditedID = useSelector(multiPolygonEditedIDState);
    const mapOptions = useSelector(mapOptionsState);

    let multiPolygonsCoords: any = [];
    let multiPolygonsIds: any = [];
    let multiPolygonsColor: any = [];
    let multiPolygonsOpacity: any = [];

    if (multiPolygonEditedID !== 0) {
        multiPolygonsInfo.filter((polygon) => {
            if (polygon.polygonId !== multiPolygonEditedID) {
                multiPolygonsIds.push(polygon.polygonId);
                multiPolygonsColor.push(polygon?.color);
                multiPolygonsOpacity.push(polygon.opacity);
                multiPolygonsCoords.push(
                    polygon.polygonCoords.map((coord: any) => {
                        return coord;
                    }),
                );
            }
        });
    } else {
        multiPolygonsInfo &&
            multiPolygonsInfo.map((polygon: any) => {
                multiPolygonsIds.push(polygon.polygonId);
                multiPolygonsColor.push(polygon?.color);
                multiPolygonsOpacity.push(polygon.opacity);
                multiPolygonsCoords.push(
                    polygon.polygonCoords.map((coord: any) => {
                        return coord;
                    }),
                );
            });
    }

    return (
        <>
            {multiPolygonsCoords &&
                multiPolygonsCoords.map((coords: any, index: number) => {
                    return (
                        coords.length > 0 && (
                            <Polygon
                                key={multiPolygonsIds[index]}
                                positions={filterPolygonPointsByDistance(coords)}
                                color={
                                    multiPolygonsColor[index]
                                        ? multiPolygonsColor[index]
                                        : mapOptions.styles.polygon.color
                                        ? mapOptions.styles.polygon.color
                                        : theme.colors.garden_polygon_color
                                }
                                fillColor={
                                    multiPolygonsColor[index]
                                        ? multiPolygonsColor[index]
                                        : mapOptions.styles.polygon.color
                                        ? mapOptions.styles.polygon.color
                                        : theme.colors.garden_polygon_color
                                }
                                fillOpacity={multiPolygonsOpacity[index] ? multiPolygonsOpacity[index] : 0}
                                // pathOptions={{ weight: 1 }}
                            />
                        )
                    );
                })}
        </>
    );
};

export default MultiPolygonsUnEditable;
